<template>
  <div class="hello">
    <transition name="fade">
        <div v-if="showRequestsSent" class="loading">
            <p>Service Requests Submitted</p>
        </div>
    </transition>

    <b-container>
        <!-- Brewers Table -->
        <table class="table">
          <tbody>
              <template v-for="brewer in servicesArray">
                <tr :key='brewer.brewerid+"id"'>
                    <td colspan='12'><h4>{{brewer.brewer}}</h4></td>
                </tr>
                <tr :key='brewer.brewerid+"services"'>
                    <!-- Line Cleaning -->
                    <td v-if="brewer.linecleaningenabled==1">
                        <b-button v-if="!brewer.linecleaning" variant="outline-secondary" @click="setService(brewer, 'linecleaning', 1)" style="height:40px; width:40px">
                        </b-button>

                        <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="setService(brewer, 'linecleaning',0)">
                            <font-awesome-icon icon="check-square" />
                        </b-button>
                        <span style="margin-left:10px">Line Cleaning</span>
                    </td>
                    <!-- Keg Pickup -->
                    <td v-if="brewer.kegpickupenabled==1">
                        <b-button v-if="!brewer.kegpickup" variant="outline-secondary" @click="setService(brewer, 'kegpickup', 1)" style="height:40px; width:40px">
                        </b-button>

                        <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="setService(brewer, 'kegpickup',0)">
                            <font-awesome-icon icon="check-square" />
                        </b-button>
                        <span style="margin-left:10px">Pick Up Empty Kegs</span>
                    </td>
                    <!-- Tap handles -->
                    <td v-if="brewer.taphandlesenabled==1">
                        <b-button v-if="!brewer.taphandles" variant="outline-secondary" @click="setService(brewer, 'taphandles', 1)" style="height:40px; width:40px">
                        </b-button>

                        <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="setService(brewer, 'taphandles',0)">
                            <font-awesome-icon icon="check-square" />
                        </b-button>
                        <span style="margin-left:10px">Tap Handles</span>
                    </td>
                    <!-- Signage -->
                    <td v-if="brewer.signageenabled==1">
                        <b-button v-if="!brewer.signage" variant="outline-secondary" @click="setService(brewer, 'signage', 1)" style="height:40px; width:40px">
                        </b-button>

                        <b-button v-else variant="outline-secondary"  style="height:40px; width:40px" @click="setService(brewer, 'signage',0)">
                            <font-awesome-icon icon="check-square" />
                        </b-button>
                        <span style="margin-left:10px">Signage</span>
                    </td>
                </tr>
                <tr :key='brewer.brewerid+"note"'>
                    <td colspan="12">
                            <b-form-textarea id="textarea-formatter" v-model="brewer.note" placeholder="Optional Note"></b-form-textarea>
                    </td>
                </tr>
              </template>
          </tbody>
      </table>

      <!-- Submit request button -->
      <b-row>
          <b-col>
              <b-button @click="submitRequest" variant="success">Submit Requests</b-button>
              <b-button style="margin-left:10px" @click="cancelRequest" variant="outline-danger">Cancel</b-button>
          </b-col>
      </b-row>

    </b-container>
      

  </div>
</template>

<script>

import { mapState } from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {    
    props: ['brewersLists'],

    computed: {
        ...mapState(['userProfileStatus', 'userProfile', 'currentUser'])
    },

    components: {
    },

    data() {
        return {
            servicesArray:[],
            localBrewersList:[],
            note:'',
            showRequestsSent:false,

        }
    },

    methods:{
        //Get profiles of breweries to see what services they are offering
        getBreweryProfiles(){
            this.servicesArray=[]
            var address
            address = this.userProfile.street1
            if(this.userProfile.street2) address = address + ', ' + this.userProfile.street2
            address = address + ', ' + this.userProfile.city + ', ' + this.userProfile.state + ', ' + this.userProfile.zip

            for (var i=0; i<this.brewersLists.length; i++){
                var thisbrewerid = this.brewersLists[i].brewerid
                var docRef = fb.usersCollection.doc(thisbrewerid);

                docRef.get().then((doc) => {
                    if (doc.exists) {
                        var thebrewer = doc.data()
                        var brewerservices = {}
                        thebrewer.brewerid = doc.id
                        var serviceObj = {brewer:thebrewer.company, brewerid:thebrewer.brewerid, pub:this.userProfile.company, 
                            pubid:this.currentUser.uid, createdOn: new Date(), address:address}
                        
                        //Create service ID
                        var randomIdString1 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
                        serviceObj.serviceid=randomIdString1
                        //User notes
                        serviceObj.note=""

                        //Check services, (null, 1) = enabled, 2 = disabled. All services enabled by default
                        //Check line cleaning enabled
                        if (('linecleaningenabled' in thebrewer)&&(thebrewer.linecleaningenabled==2)){
                            //Skip
                            serviceObj.linecleaningenabled=2
                            console.log("Line cleaning skipped")
                        }
                        else{
                            serviceObj.linecleaningenabled=1
                            serviceObj.linecleaning=0
                            serviceObj.linecleaningcompleted=0
                        } 

                        //Check keg pickup
                        if (('kegpickupenabled' in thebrewer)&&(thebrewer.kegpickupenabled==2)){
                            //Skip
                            serviceObj.kegpickupenabled=2
                        }
                        else{
                            serviceObj.kegpickupenabled=1
                            serviceObj.kegpickup=0
                            serviceObj.kegpickupcompleted=0
                        } 

                        //Check tap handles
                        if (('taphandlesenabled' in thebrewer)&&(thebrewer.taphandlesenabled==2)){
                            //Skip
                            serviceObj.taphandlesenabled=2
                        }
                        else{
                            serviceObj.taphandlesenabled=1
                            serviceObj.taphandles=0
                            serviceObj.taphandlescompleted=0
                        } 
                        //Check signage
                        if (('signageenabled' in thebrewer)&&(thebrewer.signageenabled==2)){
                            //Skip
                            serviceObj.signageenabled=2
                        }
                        else{
                            serviceObj.signageenabled=1
                            serviceObj.signage=0
                            serviceObj.signagecompleted=0
                        } 
                        
                        //Add to services array
                        this.servicesArray.push(serviceObj)


                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch((error) => {
                    console.log("Error getting document:", error);
                });

            }

        },

        //Submit service requests
        submitRequest(){
            console.log("Submitting service requests")
            
            for (var i=0; i<this.servicesArray.length; i++){
                //Add only if at least one service selected
                var thisService = this.servicesArray[i]
                if(thisService.linecleaning||thisService.kegpickup||thisService.taphandles||thisService.signage)
                    fb.servicesCollection.add(this.servicesArray[i])
            }
            
            this.showRequestsSent = true
            setTimeout(() => { 
                this.showRequestsSent = false;
                this.$emit('closeServicesModal', 1)
                }, 2000)

            
        },

        //Cancel request
        cancelRequest(){
            this.$emit('closeServicesModal', 0)
        },

        //Set line cleaning
        setService(brewer,service, val){
            //Find brewer in array
            const existingBrewerindex = this.servicesArray.findIndex(item => item.brewerid === brewer.brewerid);
            if(existingBrewerindex>=0){

                if(service=='linecleaning'){
                    var thisService = this.servicesArray[existingBrewerindex]
                    thisService.linecleaning=val
                }
                if(service=='kegpickup'){
                    var thisService = this.servicesArray[existingBrewerindex]
                    thisService.kegpickup=val
                }
                if(service=='taphandles'){
                    var thisService = this.servicesArray[existingBrewerindex]
                    thisService.taphandles=val
                }
                if(service=='signage'){
                    var thisService = this.servicesArray[existingBrewerindex]
                    thisService.signage=val
                }

            }
        }
    },

    mounted(){

        //Make local copy of brewers list
        this.localBrewersList = JSON.parse(JSON.stringify(this.brewersLists));

        var address
        address = this.userProfile.street1
        if(this.userProfile.street2) address = address + ', ' + this.userProfile.street2
        address = address + ', ' + this.userProfile.city + ', ' + this.userProfile.state + ', ' + this.userProfile.zip

        //Create request array
        this.servicesArray=[]
        for (var i=0; i<this.localBrewersList.length; i++){
            var serviceObj = {brewer:this.localBrewersList[i].company, brewerid:this.localBrewersList[i].brewerid, pub:this.userProfile.company, pubid:this.currentUser.uid, createdOn: new Date(), address:address}
            serviceObj.linecleaning=0
            serviceObj.kegpickup=0
            serviceObj.taphandles=0
            serviceObj.signage=0
            serviceObj.linecleaningcompleted=0
            serviceObj.kegpickupcompleted=0
            serviceObj.taphandlescompleted=0
            serviceObj.signagecompleted=0
            var randomIdString1 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
            serviceObj.serviceid=randomIdString1
            serviceObj.note=this.note

            //Add phone
            if(this.userProfile.phone) serviceObj.phone = this.userProfile.phone
            //Add Contact name
            if(this.userProfile.contactname) serviceObj.contactname = this.userProfile.contactname

            //Get services of all breweries in the list
            this.getBreweryProfiles()

            //this.servicesArray.push(serviceObj)

        }
    },
}
</script>

